import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PurchaseOrder } from 'src/app/models/purchase-order';
import { PurchaseOrderItem } from 'src/app/models/purchase-order-item.model';

@Component({
  selector: '[app-tr-purchase-order-item]',
  template: `    
    <td class="align-middle">
      <div class="d-flex">
        <div>
          <img [src]="purchaseOrderItem?.supplier_item?.thumbnail" style="max-width: 20px;">
        </div>
        {{ purchaseOrderItem?.stock?.name }}
      </div>
    </td>
    <td></td>
    <td class="align-middle text-center">{{ purchaseOrderItem?.supplier_item?.code }}</td>
    <td class="align-middle text-center">{{ purchaseOrderItem?.quantity }}</td>
    <td class="align-middle text-center">{{ purchaseOrderItem?.unit_price | currency }}</td>
    <td class="align-middle text-center">{{ purchaseOrderItem?.total | currency }}</td>
    
    <td class="align-middle text-center">{{ purchaseOrderItem?.created_at | date: 'yyyy-MM-dd HH:mm' }}</td>
    <td class="align-middle text-center">{{ purchaseOrder?.created_by?.name }}</td>
    <td class="align-middle text-center">{{ purchaseOrder?.approved_by?.name }}</td>
    <td class="align-middle text-center">
      <div class="btn-group">
        <button
          class="btn btn-zazz-dark btn-sm me-2"
          (click)="editItem()">
          Edit
        </button>
        <button
          class="btn btn-zazz-default btn-sm"
          (click)="confirmDelete()"
          [disabled]="isDeleting">
          {{ isDeleting ? 'Deleting...' : 'Delete' }}
        </button>
      </div>
    </td>
  `,
  styles: ``
})
export class TrPurchaseOrderItemComponent {
  @Input() purchaseOrderItem: PurchaseOrderItem | null = null;
  @Input() purchaseOrder: PurchaseOrder | null = null;
  @Input() profile: any;
  @Input() permissions: any;
  @Output() editRequested = new EventEmitter<PurchaseOrderItem>();
  @Output() itemDeleted = new EventEmitter<string>();
  isDeleting: boolean = false;

  constructor() {
    // Initialization logic can go here if needed
  }
  editItem() {
    if (this.purchaseOrderItem) {
      this.editRequested.emit(this.purchaseOrderItem);
    }
  }
  confirmDelete() {
    if (this.purchaseOrderItem) {
      this.isDeleting = true;
      this.itemDeleted.emit();
      // Simulate deletion process
      setTimeout(() => {
        this.isDeleting = false;
      }, 2000); // Simulate a delay for deletion
    }
  }
  ngOnInit() {
    // Any initialization logic can go here
  }
}
